import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ProductInvestment } from '../../../Models/Models/PortfolioAnalysis/Investment/ProductInvestment';
import { AssetClassType } from '../../../Constants/Enums/Domain/Instrument/AssetClassType';
import { IJsonDate } from '../../../System/IJsonDate';
import { ViewType } from '../../../Mapping/PortfolioAnalysis/Investment/Enum/ViewType';

declare var IS_RUNNING_IN_APP_POOL;

export class PortfolioInvestmentClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyIds: Array<string>, assetClassType: AssetClassType, asAt: IJsonDate, viewType: ViewType): Promise<Array<ProductInvestment>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Investment/PortfolioInvestment/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, assetClassType: assetClassType, asAt: asAt, viewType: viewType }

    return AjaxWrapper.get<Array<ProductInvestment>, any>(url, data);
  }
}

